import styled from 'styled-components';

import { Select } from 'components/shared/form/InfiniteScrollDropdown';
import { useDiscardChanges } from 'context/discardChanges';
import Client from 'models/Client';

type Props = {
  clients: Client[];
  selectedClientId: string;
  dirty: boolean;
  onChange: (client: Client) => void;
};

export default function ClientSelector({ clients, selectedClientId, dirty, onChange }: Props) {
  const { openDiscardChangesModal } = useDiscardChanges();

  const handleChange = (client: Client) => {
    if (!client || client.id === selectedClientId) return;

    // Switching clients resets the form to the new client's data, so a dirty
    // form has to be explicitly discarded first.
    if (dirty) {
      openDiscardChangesModal({ navigatingAway: false, onConfirm: () => onChange(client) });
    } else {
      onChange(client);
    }
  };

  return (
    <SelectorContainer data-testid='client-selector'>
      <Select<Client>
        options={clients}
        value={clients.find((client) => client.id === selectedClientId) ?? null}
        onChange={handleChange}
        getOptionValue={(client) => client.id}
        getOptionLabel={(client) => client.name}
      />
    </SelectorContainer>
  );
}

const SelectorContainer = styled.div`
  margin-top: 12px;
  min-width: 140px;
  width: max-content;

  [class*='singleValue'] {
    color: ${({ theme }) => theme.colors.blue100};
  }

  [class*='indicatorContainer'] {
    color: ${({ theme }) => theme.colors.blue100};
  }
`;
